import { forwardRef } from 'react';
import { cn } from '../../util';

interface TableProps extends React.HTMLAttributes<HTMLTableElement> {
  compact?: boolean;
}

const Table = forwardRef<HTMLTableElement, TableProps>(({ className, compact, ...props }, ref) => (
  <div className="relative w-full">
    <table
      ref={ref}
      data-compact={compact ? '' : undefined}
      className={cn('w-full caption-bottom text-base', className)}
      {...props}
    />
  </div>
));

Table.displayName = 'Table';

export default Table;
